import FetchStatusRepository    from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository         from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import RecordTemplate           from "../../../../domain/record/template/RecordTemplate";
import RecordTemplateId         from "../../../../domain/record/template/RecordTemplateId";
import RecordTemplateName       from "../../../../domain/record/template/RecordTemplateName";
import RecordTemplateRepository from "../../../../domain/record/template/RecordTemplateRepository";
import RecordTemplateRevision   from "../../../../domain/record/template/RecordTemplateRevision";
import RecordTemplates          from "../../../../domain/record/template/RecordTemplates";
import WidgetItem               from "../../../../domain/record/widget/item/WidgetItem";
import WidgetItemId             from "../../../../domain/record/widget/item/WidgetItemId";
import WidgetItems              from "../../../../domain/record/widget/item/WidgetItems";
import WidgetItemTitle          from "../../../../domain/record/widget/item/WidgetItemTitle";
import WidgetItemValue          from "../../../../domain/record/widget/item/WidgetItemValue";
import Widget                   from "../../../../domain/record/widget/Widget";
import WidgetCoordinate         from "../../../../domain/record/widget/WidgetCoordinate";
import WidgetId                 from "../../../../domain/record/widget/WidgetId";
import Widgets                  from "../../../../domain/record/widget/Widgets";
import WidgetTitle              from "../../../../domain/record/widget/WidgetTitle";
import WidgetTypeClass          from "../../../../domain/record/widget/WidgetTypeClass";
import WidgetValue              from "../../../../domain/record/widget/WidgetValue";
import FetchStatusDataSource    from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource         from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import RecordTemplateDataSource from "../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";

class GetRecordTemplates {
  constructor(
    private readonly dispatch,
    private readonly repository: RecordTemplateRepository = new RecordTemplateDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch)
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.repository.findAll();
      const list: RecordTemplate[] = response.data.templates.map(template =>
        new RecordTemplate(
          new RecordTemplateId(template.id),
          new RecordTemplateRevision(template.revision),
          new RecordTemplateName(template.name),
          new Widgets(
            template.widgets.map(widget =>
              new Widget(
                new WidgetId(widget.id),
                new WidgetTypeClass(widget.type),
                new WidgetCoordinate(widget.coordinate.x, widget.coordinate.y),
                new WidgetTitle(widget.title),
                new WidgetValue(widget.value),
                new WidgetItems(
                  widget.items.map(item =>
                    new WidgetItem(
                      new WidgetItemId(item.id),
                      new WidgetItemTitle(item.title),
                      new WidgetItemValue(item.value)
                    )
                  )
                )
              )
            )
          )
        )
      );

      this.repository.setTemplates(new RecordTemplates(list));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetRecordTemplates;
